module.exports = __webpack_public_path__ + "static/img/wsbx3.205a903.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wsbx3.png
// module id = PtKo
// module chunks = 1